import api from './api';

export const userService = {
  getCurrentUser: async () => {
    return await api.get('/users/me');
  },
  
  updateProfile: async (userData) => {
    return await api.put('/users/me', userData);
  },
  
  changePassword: async (currentPassword, newPassword) => {
    return await api.post('/users/change-password', {
      current_password: currentPassword,
      new_password: newPassword
    });
  }
};

export default userService;
